// Canonical gender values stored on player_accounts. players.players holds mixed case
// ("Male"/"male") and "Unspecified", so anything read from there is normalised through here first.
export const GENDER_VALUES = ["male", "female", "other"] as const;
export type Gender = (typeof GENDER_VALUES)[number];

/** Canonical form, or null when we genuinely do not know - "Unspecified" included. */
export function normaliseGender(raw: string | null | undefined): Gender | null {
  const norm = (raw ?? "").trim().toLowerCase();
  return (GENDER_VALUES as readonly string[]).includes(norm) ? (norm as Gender) : null;
}
